// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-v3-banner[data-v-a0013410]{width:100%;font-size:0}.details-v3-banner img[data-v-a0013410]{width:100%}", ""]);
// Exports
module.exports = exports;
